export const
    cmdId = 'blockly-script',
    keyBlocklyXml = 'blockly-xml';